/**
 * @file: useOpenDashboardMiniprogram.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export const useOpenDashboardMiniprogram = () => {
  return {
    canOpenDashboardMiniprogram: false,
    openDashboardMiniprogram: () => {
      throw new Error(
        'Open dashboard miniprogram on web is not supported right now',
      );
    },
  };
};
